import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import './Welcome.scss';
import BorderImage from '../assets/images/border.js';
import DeadlineHeader from '../assets/images/deadline_header.js';
import DeathTime from '../assets/images/deathTime.js';
import Header from '../components/Header.js';
import { handlePayment } from '../utils/payment';
import Star from '../assets/images/star.js';

const Welcome = () => {
  const dispatch = useDispatch();
  const { userData, deathReasons, language } = useSelector(state => state.user);
  const [refCode, setRefCode] = useState(null);

  const { 
    deathDate, 
  } = useSelector(state => state.user);

  let redirectPath = '/welcome';

  if (!deathDate) {
    redirectPath = '/main';
  } else {
    redirectPath = '/deadline';
  }
  
  useEffect(() => {
    if (userData?.invited_by) {
      setRefCode(userData.invited_by);
      console.log(userData.invited_by, refCode);
    }
  }, [refCode, userData]);

  const handlePaymentClick = () => {
    handlePayment({ dispatch });
  };

  console.log(language);

  return (
    <>
      <div className="welcome">
        <div className="welcome__content">
           <Header />
           <div className="welcome__content-body">
            <BorderImage />
            <DeadlineHeader />
            <DeathTime />
            <div className="welcome__content-body-text">
              {language === 'RUS'
              ? 'Твой личный ИИ-агент по долголетию'
              : 'Your Personal LONGEVITY AI-AGENT'}
            </div>
            <div className='welcome__content-body-buttons'>
              <Link to={redirectPath} className="welcome__content-body-link">
                {language === 'RUS'
                ? redirectPath === '/main' ? 'Узнать когда я умру' : 'Результаты теста'
                : redirectPath === '/main' ? 'When Will I Die?' : 'Test results'}
              </Link>
              {!deathReasons && <button 
                onClick={handlePaymentClick}
                className="welcome__content-body-link"
              >
                <Star />
                {language === 'RUS'
                ? 'Полный доступ к ИИ-агенту'
                : 'Full Access'}
              </button>}
            </div>
           </div>
           <footer>
            <div className="footer">
              {language === 'RUS' ? (
                <span>
                  *Нажимая на кнопку, я подтверждаю свое согласие <br/> с{' '}
                  <Link className="welcome__footer-link" to="/terms">
                    условиями использования
                  </Link>
                  {' '}и{' '}
                  <Link className="welcome__footer-link" to="/privacy">
                    политикой конфиденциальности
                  </Link>
                  .
                </span>
              ) : (
                <span>
                  *By clicking on the button above, you accept our{' '}<br/>
                  <Link className="welcome__footer-link" to="/terms">
                    Terms & Conditions
                  </Link>
                  {' '}and{' '}
                  <Link className="welcome__footer-link" to="/privacy">
                    Privacy Policy
                  </Link>
                </span>
              )}
            </div>
           </footer>
        </div>
      </div>
    </>
  );
};

export default Welcome;
